import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { ShipOwnerCompanyPayload, ShipOwnerCompanyResponse } from "@/types/interface/ship-owner-company";

export const useShipOwnerCompanyStore = defineStore("shipOwnerCompanyStore", () => {
  const owner = ref<ShipOwnerCompanyResponse>();
  const owners = ref<ShipOwnerCompanyResponse[]>([]);

  function initOwners(data: any) {
    owners.value = data?.data;
  }

  function addNewOwner(data: any) {
    owner.value = data;
  }

  async function dispatchGetList(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.shipOwnerCompany.getShipOwnerCompany(page, limit, queryParam);
      if (status === 200 ) {
        initOwners(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idShipOwnerCompany = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.shipOwnerCompany.findShipOwnerCompany(idShipOwnerCompany);
      if (status === 200 ) {
        addNewOwner(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: ShipOwnerCompanyPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.shipOwnerCompany.createShipOwnerCompany(payload);
      if (status === 200 ) {
        addNewOwner(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idShipOwnerCompany = "", payload: ShipOwnerCompanyPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.shipOwnerCompany.updateShipOwnerCompany(idShipOwnerCompany, payload);
      if (status === 200 ) {
        addNewOwner(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idShipOwnerCompany = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.shipOwnerCompany.deleteShipOwnerCompany(idShipOwnerCompany);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    owner,
    owners,
    initOwners,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetList,
    dispatchDelete
  };
});